import { t } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { Avatar } from "@whoosh/design-system/src/components/display";
import {
  HStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";

import { getBookingPlayerNoun } from "../../../../../../../../BookingSummary/utils/getBookingPlayerNoun";
import { getRoundFromIdAtom } from "../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";
import { currentBookingAtom } from "../../../../../../../atoms/stores";
import { RoundOverflowMenu } from "../RoundOverflowMenu/RoundOverflowMenu";

type Props = {
  roundId: string;
};
export const RoundPlayerLine = ({ roundId }: Props) => {
  const round = useAtomValue(getRoundFromIdAtom(roundId));
  const currentBooking = useAtomValue(currentBookingAtom);
  const playerNoun = getBookingPlayerNoun({
    bookingType: currentBooking?.type,
    copyOverrides: currentBooking?.copyOverrides,
  });

  const isNonPlaying = !!round?.isNonPlayingHost;

  const fullName =
    round?.player.clientType === "unknownCustomer"
      ? t`New ${playerNoun.singular}`
      : round?.player.clientType === "unknownGuest"
      ? t`New Guest`
      : round?.player.clientType === "memberHold"
      ? t`Member Hold`
      : (round?.player.clientType === "guest" ||
          round?.player.clientType === "newGuest" ||
          round?.player.clientType === "member" ||
          round?.player.clientType === "customer") &&
        round.player.firstName &&
        round.player.lastName
      ? `${round.player.firstName ?? ""} ${round.player.lastName ?? ""}`
      : t`New ${playerNoun.singular}`;

  const avatarType =
    round?.player.clientType === "member"
      ? "member"
      : round?.player.clientType === "guest" ||
        round?.player.clientType === "newGuest"
      ? "guest"
      : round?.player.clientType === "unknownCustomer"
      ? "unknownCustomer"
      : round?.player.clientType === "unknownGuest"
      ? "unknownGuest"
      : round?.player.clientType === "memberHold"
      ? "memberHold"
      : "unknownMemberHold";

  return (
    <HStack testID="round-player-line">
      <HStack flex={1} alignItems="center" gap={1}>
        <HStack gap={3} alignItems="center">
          <Avatar
            size="xs"
            type={avatarType}
            firstName={
              round?.player.clientType === "member" ||
              round?.player.clientType === "guest" ||
              round?.player.clientType === "customer"
                ? round.player.firstName
                : ""
            }
            lastName={
              round?.player.clientType === "member" ||
              round?.player.clientType === "guest" ||
              round?.player.clientType === "customer"
                ? round.player.lastName
                : ""
            }
          />
          <Text>{fullName}</Text>
        </HStack>

        <HStack gap={1} alignItems="center">
          {isNonPlaying ? (
            <Text
              variant="mainBaseMedium"
              color="text-secondary"
            >{t`(Non-Playing Host)`}</Text>
          ) : null}

          {round?.isOwner ? (
            <Box borderWidth={1} borderRadius="1" borderColor="outline-default">
              <Text variant="mainMicro" padding={1}>{t`OWNER`}</Text>
            </Box>
          ) : null}
        </HStack>
      </HStack>
      <Box>
        <RoundOverflowMenu roundId={roundId} />
      </Box>
    </HStack>
  );
};
